import { useState } from "react";
import { LanguageContent } from "../system/types/api/languageApi";
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers";

const useTranslations = () => {

    const [data, setData] = useState<LanguageContent>({});

    useSelector((state: RootState) => {
        if (state.system.appConfig.translations !== data) {
            setData(state.system.appConfig.translations);
        }
    });

    const t = (key: string, defString?: string): string => {

        const keys = key.split('.');

        const group = keys[0] ?? '';
        const entry = keys[1] ?? '';

        if (typeof defString === 'undefined') {
            defString = '';
        }

        if (group === '' || entry === '') {
            return defString;
        }

        if (data === null) {
            return defString;
        }

        if (typeof data[group] === 'undefined') {
            return defString;
        }

        if (typeof data[group][entry] === 'undefined') {
            return defString;
        }

        return data[group][entry];

    };

    return { t };

}

export { useTranslations };
